import React from 'react';
import {getInitialMeta} from "@helpers/HelperInitialPageState";

const ContentD1StructuredData = ({data}) => {
	if (!data.blockContent.title || !data.blockContent.img || !data.blockContent.videoId) {
		return null;
	}

	const name = data.blockContent.title ?? data.blockIntro.top.blockTitle ?? data.blockIntro.bottom.blockTitle ?? 'Video';
	const desc = data.blockIntro.top.blockDesc ?? data.blockIntro.bottom.blockDesc ?? 'Superhosting video';
	const url = data.blockContent.platform === 'wistia' ? "https://superhosting.wistia.com/medias/" + data.blockContent.videoId : "https://youtu.be/" + data.blockContent.videoId;
	const img =
	  getInitialMeta('siteURL').replace(/\/+$/, '') + '/' +
	  data.blockContent.img.replace(/^\/+/, '');

	let structuredData = {
		"@context": "https://schema.org",
		"@type": "VideoObject",
		"name": name,
		"description": desc,
		"thumbnailUrl": [
			img
		],
		"uploadDate": data.blockContent.uploadDate,
		"contentUrl": url
	};

	return (
	  <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(structuredData)}}></script>
	)
}

export default ContentD1StructuredData;
